import { useInsightsSectionContent } from './useInsightsSectionContent';
import { parseInsightsFeaturedContent } from '../utils/insightsContent';

export const useInsightsFeaturedContent = () =>
  useInsightsSectionContent(parseInsightsFeaturedContent);
